module.exports = __webpack_public_path__ + "static/media/videoFilled.eca61cca.svg";